import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SortedHeader from "../../../components/Tables/SortedHeader";
import { t } from "../../../i18n";

export default function TechRoleList({
  list,
  setCreateOrEdit,
  setForDelete,
  searchObject,
  setSearchObject
}) {
  let { t } = useTranslation();
  const [headers, setHeaders] = useState([
    { label: t("Tech Role Name"), field: "Description" },
    { label: t("Tech Area"), fieldId: "TechAreaId" },
    { label: "" }
  ]);

  return (
    <div className="table-wrap quiz-management">
      <table>
        <thead>
          <SortedHeader
            searchObject={searchObject}
            setSearchObject={setSearchObject}
            headers={headers}
            setHeaders={setHeaders}
          />
        </thead>
        <tbody>
          {list.map((techRole) => (
            <tr>
              <td className="skill-name text-truncate">
                {t(techRole.description)}
              </td>
              <td className="skill-name text-truncate">
                {t(techRole.techArea)}
              </td>
              <td className="actions">
                <button
                  onClick={() => setCreateOrEdit(techRole.id)}
                  className="action-button-settings"
                  type="button"
                >
                  <i class="bi bi-pencil-square"></i>
                </button>

                <button
                  onClick={() => setForDelete(techRole)}
                  className="action-button-settings"
                  type="button"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
